import clsx from 'clsx';
import { amountMap } from './TradesColumnsDef';

const upperBound = (amount: string): number => {
  const matches = (amount ?? '').match(/[\d,]+(?:\.\d+)?/g);
  if (!matches) return 0;
  return Math.max(...matches.map(value => Number(value.replace(/,/g, ''))));
};

const tierFor = (amount: string): number => {
  const upper = upperBound(amount);
  if (upper > 100000) return 3;
  if (upper > 50000) return 2;
  return 1;
};

interface AmountBagsProps {
  amount: string;
  transactionType: string;
}

export const AmountBags = ({ amount, transactionType }: AmountBagsProps) => {
  const label = (amountMap as Record<string, string>)[amount] ?? amount ?? '';
  const tier = tierFor(amount);
  const isBuy = (transactionType ?? '').toUpperCase().startsWith('P');

  return (
    <div className="flex flex-col gap-[3px]">
      <span aria-hidden="true" className="flex gap-px">
        {[1, 2, 3].map(position => (
          <span
            className={clsx(
              'text-[13px] font-extrabold leading-tight',
              isBuy ? 'text-[#2fb344]' : 'text-[#e5484d]',
              position <= tier ? 'opacity-100' : 'opacity-[0.18]',
            )}
            key={position}
          >
            $
          </span>
        ))}
      </span>
      <span className="text-[11px] font-bold text-bzgray-600">{label}</span>
    </div>
  );
};
